<template>
  <v-container class="pa-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1" style="display: flex;">{{ $t('Įgaliojimų registro paslaugos') }}<el-tooltip tooltip="Vieša paieška. Paieška. Įgaliojimų registro paslaugos" mainPubTitle></el-tooltip></h1>
    <v-row class="mb-0 pb-0">
      <v-col cols="12" md="12">
        <v-btn-toggle mandatory v-model="type">
          <v-btn :class="getForAccessibility ? ' btn-for-disabled ' : ''" active-class="active-btn-group-item" small value="search">
            <v-icon style="padding-right: 4px">mdi-account</v-icon>
            <span>{{ $t('Vieša paieška') }}</span>
          </v-btn>
          <v-btn :class="getForAccessibility ? ' btn-for-disabled ' : ''" active-class="active-btn-group-item" small value="paid">
            <v-icon style="padding-right: 4px">mdi-bank</v-icon>
            <span>{{ $t('Mokami išrašai') }}</span>
          </v-btn>
        </v-btn-toggle>
      </v-col>
      <!-- View Form  -->
      <template v-if="showSearch">
        <!-- title  -->
        <h2 class="ml-3 mt-4" style="display: flex;">{{ $t('Vieša paieška') }}<el-tooltip tooltip="Vieša paieška. Paieška. Vieša paieška" pubTitle></el-tooltip></h2>
        <!-- form  -->
        <v-col class="pt-0" cols="12" md="12">
          <public-search-form />
        </v-col>
      </template>
      <!-- Edit Form  -->
      <template v-if="showPaidSearch">
        <!-- title  -->
        <h2 class="ml-3 mt-4" style="display: flex;">{{ $t('Mokami išrašai') }}<el-tooltip tooltip="Vieša paieška. Paieška. Mokami išrašai" pubTitle></el-tooltip></h2>
        <!-- form  -->
        <v-col class="pt-0" cols="12" md="12">
          <public-search-paid-form />
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import PublicSearchPaidForm from './components/PublicSearchPaidForm'
import PublicSearchForm from './components/PublicSearchForm'
import { mapGetters } from 'vuex'

export default {
  name: 'NewOrder',
  components: {
    PublicSearchForm,
    PublicSearchPaidForm,
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      type: '',
    }
  },
  computed: {
    ...mapGetters(['getForAccessibility']),
    showSearch() {
      return this.type === 'search'
    },
    showPaidSearch() {
      return this.type === 'paid'
    },
  },

}
</script>
<style lang="scss" scoped>
.btn-for-disabled{
  color: black !important;
  background-color: #d6d6d6 !important;
}
</style>
